// extracted by mini-css-extract-plugin
export default {"quizes_container":"Quizes_quizes_container__dOJLq","quiz_title":"Quizes_quiz_title__t9V-h"};